<div class="customMenu relative">
  <ng-container>
    @for (item of menuItems(); track item.label) {
      @if (item.route && !isFirstLogin()) {
        <a
          [routerLink]="item.route"
          routerLinkActive="sidebar-active-route"
          [routerLinkActiveOptions]="{ exact: true }"
          class="custom-menu-link"
          (click)="closeSidebar.emit()"
        >
          <span [class]="item.icon + ' custom-menu-link__icon'"></span>
          <span class="custom-menu-link__label">
            @if (item.route === INBOX_ROUTE && pendingCount() > 0) {
              {{ item.label }} ({{ pendingCount() }})
            } @else {
              {{ item.label }}
            }
          </span>
        </a>
      } @else if (item.url) {
        <a
          [href]="item.url"
          target="_blank"
          class="custom-menu-link"
          [ariaLabel]="
            'Link zewnętrzny otwierany w nowej karcie przeglądarki' + item.label
          "
          (click)="closeSidebar.emit()"
        >
          <span [class]="item.icon + ' custom-menu-link__icon'"></span>
          <span class="custom-menu-link__label">{{ item.label }}</span>
        </a>
      } @else if (item.action) {
        <button
          class="custom-menu-link cursor-pointer w-full"
          [attr.aria-label]="item.ariaLabel ?? null"
          (click)="item.action()"
        >
          <span [class]="item.icon + ' custom-menu-link__icon'"></span>
          <span class="custom-menu-link__label text-left">{{
            item.label
          }}</span>
        </button>
      }
    }
  </ng-container>
</div>
